<!-- Zweck: Stellt die HTML-Struktur für shop bonus punkte icons component im Frontend bereit. -->
<div class="bpiconbox">
  @for (p of punkte|async; track p) {
    <button mat-icon-button (click)="showDetails(p)">
      <svg-icon matBadge="{{p.level}}"
        matTooltip="{{getTooltip(p)}}">favorit-voll
      </svg-icon>
    </button>
  }
</div>
